import { baseThemeValues } from 'constants/common';

const headFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 500,
};

const cellFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '13px',
  fontWeight: 400,
};

export const allCommentsModalTheme = {
  table: {
    borderColor: 'palette.tertiary.20',
    borderRadius: '0',
    borderWidth: '1px',
    cell: {
      ...cellFont,
      text: 'palette.tertiary.95',
    },
    empty: {
      text: 'palette.tertiary.50',
    },
    head: {
      ...headFont,
      text: 'palette.tertiary.50',
    },
  },
};
